import { IDataLayer } from '../tealium/data_layer';

export interface IAnalyticsEventHandler {
  (eventName: string, eventData: IDataLayer): void;
}

// TODO: flesh this out with all possible events
interface IAnalyticsEvents {
  [key: string]: IAnalyticsEventHandler;
}

export const eventRegistry: IAnalyticsEvents = {};

export function registerAnalyticsEventHandler(eventName: string, handler: IAnalyticsEventHandler) {
  eventRegistry[eventName] = handler;
}
